import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../fnx/showError";
import { useDispatch } from "react-redux";
import { benefitClearData, patchBeneficiaryClearData, } from "../../../store/beneficiary/actions";
import { patchInsuredClearData, postInsuredClearData, } from "../../../store/insured/actions";
import { startWorkFlowClearData } from "../../../store/workFlow/actions";
export var useErrorHandling = function (_a) {
    var errorPersonByDocument = _a.errorPersonByDocument, errorOneQuote = _a.errorOneQuote, errorInsured = _a.errorInsured, errorCatalogGender = _a.errorCatalogGender, errorCountries = _a.errorCountries, errorRegion = _a.errorRegion, errorUpdateQuote = _a.errorUpdateQuote, errorPlan = _a.errorPlan, errorBeneficiary = _a.errorBeneficiary, errorIdentificationType = _a.errorIdentificationType, errorUpdatePerson = _a.errorUpdatePerson, errorPatchBeneficiary = _a.errorPatchBeneficiary, errorPatchInsured = _a.errorPatchInsured, errorBenefit = _a.errorBenefit, errorPostInsured = _a.errorPostInsured, errorPlans = _a.errorPlans, errorUploadDocuments = _a.errorUploadDocuments, errorPaymentMode = _a.errorPaymentMode, errorCertificateQuote = _a.errorCertificateQuote, errorStartWorkflow = _a.errorStartWorkflow, errorPolicyConfirm = _a.errorPolicyConfirm, setSeeToast = _a.setSeeToast;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    // Error: Person by Document
    useEffect(function () {
        if (errorPersonByDocument) {
            showErrorToast(errorPersonByDocument, setSeeToast, t);
        }
    }, [errorPersonByDocument]);
    // Error: One Quote
    useEffect(function () {
        if (errorOneQuote) {
            showErrorToast(errorOneQuote, setSeeToast, t);
        }
    }, [errorOneQuote]);
    // Error: Insured
    useEffect(function () {
        if (errorInsured) {
            showErrorToast(errorInsured, setSeeToast, t);
        }
    }, [errorInsured]);
    // Error: Catalog Gender
    useEffect(function () {
        if (errorCatalogGender) {
            showErrorToast(errorCatalogGender, setSeeToast, t);
        }
    }, [errorCatalogGender]);
    // Error: Countries
    useEffect(function () {
        if (errorCountries) {
            showErrorToast(errorCountries, setSeeToast, t);
        }
    }, [errorCountries]);
    // Error: Region
    useEffect(function () {
        if (errorRegion) {
            showErrorToast(errorRegion, setSeeToast, t);
        }
    }, [errorRegion]);
    // Error: Update Quote
    useEffect(function () {
        if (errorUpdateQuote) {
            showErrorToast(errorUpdateQuote, setSeeToast, t);
        }
    }, [errorUpdateQuote]);
    // Error: Plan
    useEffect(function () {
        if (errorPlan) {
            showErrorToast(errorPlan, setSeeToast, t);
        }
    }, [errorPlan]);
    // Error: Beneficiary
    useEffect(function () {
        if (errorBeneficiary) {
            showErrorToast(errorBeneficiary, setSeeToast, t);
        }
    }, [errorBeneficiary]);
    // Error: Identification Type
    useEffect(function () {
        if (errorIdentificationType) {
            showErrorToast(errorIdentificationType, setSeeToast, t);
        }
    }, [errorIdentificationType]);
    // Error: Update Person
    useEffect(function () {
        if (errorUpdatePerson) {
            showErrorToast(errorUpdatePerson, setSeeToast, t);
        }
    }, [errorUpdatePerson]);
    // Error: Patch Beneficiary (con limpieza de datos)
    useEffect(function () {
        if (errorPatchBeneficiary) {
            showErrorToast(errorPatchBeneficiary, setSeeToast, t);
            dispatch(patchBeneficiaryClearData());
        }
    }, [errorPatchBeneficiary]);
    // Error: Patch Insured (con limpieza de datos)
    useEffect(function () {
        if (errorPatchInsured) {
            showErrorToast(errorPatchInsured, setSeeToast, t);
            dispatch(patchInsuredClearData());
        }
    }, [errorPatchInsured]);
    // Error: Benefit (con limpieza de datos)
    useEffect(function () {
        if (errorBenefit) {
            showErrorToast(errorBenefit, setSeeToast, t);
            dispatch(benefitClearData());
        }
    }, [errorBenefit]);
    // Error: Post Insured (con limpieza de datos)
    useEffect(function () {
        if (errorPostInsured) {
            showErrorToast(errorPostInsured, setSeeToast, t);
            dispatch(postInsuredClearData());
        }
    }, [errorPostInsured]);
    // Error: Plans
    useEffect(function () {
        if (errorPlans) {
            showErrorToast(errorPlans, setSeeToast, t);
        }
    }, [errorPlans]);
    // Error: Upload Documents
    useEffect(function () {
        if (errorUploadDocuments) {
            showErrorToast(errorUploadDocuments, setSeeToast, t);
        }
    }, [errorUploadDocuments]);
    // Error: Payment Mode
    useEffect(function () {
        if (errorPaymentMode) {
            showErrorToast(errorPaymentMode, setSeeToast, t);
        }
    }, [errorPaymentMode]);
    // Error: Certificate Quote
    useEffect(function () {
        if (errorCertificateQuote) {
            showErrorToast(errorCertificateQuote, setSeeToast, t);
        }
    }, [errorCertificateQuote]);
    // Error: Start Workflow (con limpieza de datos)
    useEffect(function () {
        if (errorStartWorkflow) {
            dispatch(startWorkFlowClearData());
        }
    }, [errorStartWorkflow]);
    // Error: Policy Confirm (envío de correo)
    useEffect(function () {
        if (errorPolicyConfirm) {
            showErrorToast(errorPolicyConfirm, setSeeToast, t);
        }
    }, [errorPolicyConfirm]);
};
